var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKeywords(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.16,
    height: 39.339,
    viewBox: "0 0 39.16 39.339",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1433",
    "data-name": "Tracciato 1433",
    d: "M21.73,1.15a1.69,1.69,0,0,1,1.517.946l5.572,11.361,11.047,1.626a1.69,1.69,0,0,1,.947,2.869L32.53,26.2l2.775,12.222A1.69,1.69,0,0,1,32.884,40.3L21.73,34.558,10.577,40.3a1.69,1.69,0,0,1-2.421-1.876L10.93,26.2,2.647,17.952a1.69,1.69,0,0,1,.946-2.869l11.048-1.626L20.213,2.1A1.69,1.69,0,0,1,21.73,1.15Zm0,5.527-4.447,9.066a1.69,1.69,0,0,1-1.271.928L7.419,17.935l6.558,6.534a1.69,1.69,0,0,1,.455,1.571l-2.179,9.6,8.7-4.482a1.689,1.689,0,0,1,1.547,0l8.7,4.482-2.179-9.6a1.691,1.691,0,0,1,.455-1.571l6.558-6.534L27.448,16.67a1.69,1.69,0,0,1-1.271-.928Z",
    transform: "translate(-2.15 -1.15)",
    fill: "#14bf96",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeywords);
export default __webpack_public_path__ + "static/media/keywords.7cea9ec062433804710450c5bf6b6289.svg";
export { ForwardRef as ReactComponent };